import bbox from "@turf/bbox";
import { province } from "../../../assets/geoJson/provinceData";
import randomColor from "randomcolor";
// export interface MapLabel {
//   minLongitude: number;
//   maxLongitude: number;
//   minLatitude: number;
//   maxLatitude: number;
//   label: string;
//   id: string;
// }

export const getMapData = () => {
  const data = [];
  province.features.forEach((x, index) => {
    const [minLng, minLat, maxLng, maxLat] = bbox(x);
    data.push({
      minLongitude: minLng,
      maxLongitude: maxLng,
      minLatitude: minLat,
      maxLatitude: maxLat,
      label: x.properties.label,
      id: `${index}_${x.properties.label}`,
    });
  });
  return data;
};

export const getDistrictData = (mapData) => {
  const data = [];
  mapData.features.forEach((x, index) => {
    const [minLng, minLat, maxLng, maxLat] = bbox(x);
    data.push({
      minLongitude: minLng,
      maxLongitude: maxLng,
      minLatitude: minLat,
      maxLatitude: maxLat,
      label: x.properties.label,
      id: `${index}_${x.properties.label}`,
    });
  });
  return data;
};

// export type MapColor = {
//   id: string;
//   color: string;
// };

export const Colors = [
  {
    id: "1",
    color: "red",
  },
  {
    id: "2",
    color: "green",
  },
  {
    id: "3",
    color: "blue",
  },
  {
    id: "4",
    color: "lightblue",
  },
  {
    id: "5",
    color: "lightgreen",
  },
  {
    id: "6",
    color: "yellow",
  },
  {
    id: "7",
    color: "orange",
  },
];

export const getColors = (item) => {
  const mapColors = [];
  item.forEach((x) => {
    Colors.push([x.properties.id.toString(), randomColor()]);
  });

  return mapColors;
};
